import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Mail, Lock, Loader2, CheckCircle2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    setErr(""); setBusy(true);
    try {
      if (token) {
        if (password.length < 8) { setErr("Mot de passe trop court (8 caractères min.)"); setBusy(false); return; }
        await api.post("/auth/reset-password", { token, password });
        setDone(true);
        setTimeout(() => nav("/login"), 2000);
      } else {
        await api.post("/auth/forgot-password", { email });
        setDone(true);
      }
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Une erreur est survenue");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F7F8F6] p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E2E5E0] p-8">
        <Link to="/login" className="text-xs text-[#6B726A] hover:text-[#1A4D2E] inline-flex items-center gap-1 mb-3">
          <ArrowLeft className="w-3.5 h-3.5" /> Retour à la connexion
        </Link>
        <h1 className="text-2xl font-medium tracking-tight text-[#0F2A1B] mb-1" style={{ fontFamily: "Outfit" }}>
          {token ? "Choisir un nouveau mot de passe" : "Mot de passe oublié"}
        </h1>
        <p className="text-sm text-[#6B726A] mb-6">
          {token ? "Saisissez votre nouveau mot de passe ci-dessous." : "Recevez un lien de réinitialisation par email."}
        </p>

        {done ? (
          <div className="text-sm text-[#1A4D2E] inline-flex items-center gap-2" data-testid="reset-done">
            <CheckCircle2 className="w-4 h-4" />
            {token ? "Mot de passe mis à jour. Redirection…" : "Si un compte existe, vous recevrez un email sous peu."}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            {token ? (
              <div>
                <label className="text-xs uppercase tracking-wider font-medium text-[#6B726A] mb-1 block">Nouveau mot de passe</label>
                <div className="relative">
                  <Lock className="w-4 h-4 absolute left-3 top-3 text-[#6B726A]" />
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                    minLength={8} required data-testid="reset-password-input"
                    className="w-full text-sm pl-9 pr-3 py-2.5 rounded-xl border border-[#E2E5E0]" placeholder="••••••••" />
                </div>
              </div>
            ) : (
              <div>
                <label className="text-xs uppercase tracking-wider font-medium text-[#6B726A] mb-1 block">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-3 top-3 text-[#6B726A]" />
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    required data-testid="reset-email-input"
                    className="w-full text-sm pl-9 pr-3 py-2.5 rounded-xl border border-[#E2E5E0]" placeholder="vous@exemple.com" />
                </div>
              </div>
            )}
            {err && <div className="text-xs text-[#E3655B]" data-testid="reset-error">{err}</div>}
            <button type="submit" disabled={busy} data-testid="reset-submit"
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-[#1A4D2E] text-white text-sm font-medium hover:bg-[#143C24] disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              {token ? "Mettre à jour" : "Envoyer le lien"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
